// extracted by mini-css-extract-plugin
export var headerDesktop = "LayoutLandingPage-module--headerDesktop--4fe38";
export var headerMobile = "LayoutLandingPage-module--headerMobile--9fe70";